export default __webpack_public_path__ + "static/media/notas_fiscais_gif_dark_mode.fa2247e3.gif";